import React, { useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useApp } from '@pixi/react';

import { gameDrawer } from '../../../services/gameDrawer';
import { iframeService } from '../../../services/iframeService';

import { loadingStore } from '../../../store/loadingStore';

import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { triggerHotJarEvent } from '../../../core/helpers/triggerHotjarEvent';

import WebView from '../../../view/web';
import MobileView from '../../../view/mobile';

const GameViewWrapper = observer(() => {
  const { ticker } = useApp();
  const reelContainerRef = useRef();
  const winContainerRef = useRef();
  const [mask, setMask] = React.useState(null);

  const { hasGameInitialState } = loadingStore;
  const { maskSprite } = useMemo(() => {
    return getGameImages();
  }, []);
  useEffect(() => {
    if (hasGameInitialState) {
      gameDrawer.execute(reelContainerRef.current, winContainerRef.current, ticker);
    }
  }, [hasGameInitialState, ticker]);

  useEffect(() => {
    if (reelContainerRef.current) {
      reelContainerRef.current.mask = mask;
    }
  }, [mask, reelContainerRef]);

  useEffect(() => {
    iframeService.sendGameIsReady();
    triggerHotJarEvent('Game is open');
  }, []);

  const { reelContainerConfig } = useMemo(() => {
    return {
      reelContainerConfig: {
        x: isMobile() ? 59 : 270,
        y: isMobile() ? 315 : 225,
      },
    };
  }, []);

  return isMobile() ? (
    <MobileView
      setMask={setMask}
      reelContainerRef={reelContainerRef}
      winContainerRef={winContainerRef}
      reelContainerConfig={reelContainerConfig}
    />
  ) : (
    <WebView
      setMask={setMask}
      maskSprite={maskSprite}
      reelContainerRef={reelContainerRef}
      winContainerRef={winContainerRef}
      reelContainerConfig={reelContainerConfig}
    />
  );
});
export default GameViewWrapper;
